import { render, staticRenderFns } from "./plaintes.html?vue&type=template&id=d3056a62&scoped=true&external"
import script from "./plaintes.js?vue&type=script&lang=js&external"
export * from "./plaintes.js?vue&type=script&lang=js&external"
import style0 from "./plaintes.scss?vue&type=style&index=0&id=d3056a62&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3056a62",
  null
  
)

export default component.exports